import { dailyRewardsEndpoints } from "./dailyRewards.api"

export const {
  useClaimDailyRewardMutation,
  useGatDailyRewardsQuery,
  endpoints: { claimDailyReward, gatDailyRewards }
} = dailyRewardsEndpoints
